// extracted by mini-css-extract-plugin
export default {"breadcrumbsRow":"Ip-z","breadcrumbForward":"Jp-z","breadcrumbBack":"Kp-z","selected":"Lp-z"};